import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const PrivacyBody = () => (
  <div className="space-y-4 text-sm leading-relaxed text-text-muted">
    <p>
      Titolare del trattamento: <strong>Seim Multiservice di Bascià Alessandro</strong> — P.IVA
      05030160757. Contatto: info@albaselection.it.
    </p>
    <p>
      I dati inseriti nel modulo (nome, contatto e informazioni sulla struttura) sono trattati con il
      solo scopo di rispondere alla tua richiesta di analisi gratuita e ricontattarti. La base
      giuridica è il consenso che presti inviando il modulo.
    </p>
    <p>
      I dati non sono ceduti a terzi per finalità di marketing e sono conservati per il tempo
      necessario a gestire la tua richiesta. In qualsiasi momento puoi richiederne l'accesso, la
      rettifica o la cancellazione scrivendo a info@albaselection.it.
    </p>
    <p className="text-xs text-navy/50">
      Questo è un testo informativo di base: verrà integrato con l'informativa completa.
    </p>
  </div>
);

const CookieBody = () => (
  <div className="space-y-4 text-sm leading-relaxed text-text-muted">
    <p>
      Questo sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento delle
      pagine. Non vengono impiegati cookie di profilazione senza il tuo consenso.
    </p>
    <p>
      Eventuali strumenti di analisi anonimizzata servono solo a migliorare l'esperienza di
      navigazione. Puoi gestire i cookie dalle impostazioni del tuo browser.
    </p>
    <p className="text-xs text-navy/50">
      Testo informativo di base: verrà integrato con la cookie policy completa.
    </p>
  </div>
);

export const LegalLink = ({ type = "privacy", label, className = "", testId }) => {
  const isPrivacy = type === "privacy";
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" data-testid={testId} className={className}>
          {label || (isPrivacy ? "Privacy Policy" : "Cookie Policy")}
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[80vh] overflow-y-auto bg-white sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy">
            {isPrivacy ? "Privacy Policy" : "Cookie Policy"}
          </DialogTitle>
        </DialogHeader>
        {isPrivacy ? <PrivacyBody /> : <CookieBody />}
      </DialogContent>
    </Dialog>
  );
};
